import { DynamicElementSpecification } from './dynamic-element-specification'

/**
 * Assert that a given value is a {@link DynamicElementSpecification}
 *
 * @param value The value that will be tested
 */
export function assertIsDynamicElement(value: unknown): asserts value is DynamicElementSpecification {
  if (typeof value === 'object') {
    let objectValue = value as Record<string, unknown>
    if (typeof objectValue?.id != 'string') {
      throw new TypeError(
        `Expected the provided argument to have property "id" with a type of "string".`
      )
    }

    if (typeof objectValue?.type != 'string') {
      throw new TypeError(
        `Expected the provided argument to have property "type" with a type of "string".`
      )
    }

    if (objectValue?.classes !== null && typeof objectValue?.classes != 'string') {
      throw new TypeError(
        `Expected the provided argument's property "classes" to be a type of "string".`
      )
    }

    if (typeof objectValue?.data != 'object') {
      throw new TypeError(
        `Expected the provided argument to have property "data" with a type of "object".`
      )
    }

    if (objectValue?.children instanceof Array && objectValue?.children?.length > 0) {
      let children = objectValue?.children as unknown[]
      children.forEach(it => assertIsDynamicElement(it))
    }
  }

  else {
    throw new TypeError(`Expected the provided argument to be type of "object", instead received "${typeof value}".`)
  }
}
